import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { HelmetDatoCms } from 'gatsby-source-datocms'

// Fonts
import Montserrat from 'typeface-montserrat'
import Oswald from 'typeface-oswald'
import Pacifico from 'typeface-pacifico'

// Layout Components
import Header from '../components/header'
import Footer from '../components/footer'
import '../scss/index.scss'

const TemplateWrapper = ({ children, data, props, location }) => (
  <div>
    <Helmet
      title="Mega House Creative"
      meta={[
        {
          name: 'description',
          content:
            'we provide custom, lightning fast websites designed to achieve real-world results',
        },
        {
          name: 'keywords',
          content:
            'web development, web design, branding, marketing, websites, website, static, react, reactjs, logo design',
        },
      ]}
    >
      {/* <script>
        {`
    {
      "use strict";

      !function() {
        var t = window.driftt = window.drift = window.driftt || [];
        if (!t.init) {
          if (t.invoked) return void (window.console && console.error && console.error("Drift snippet included twice."));
          t.invoked = !0, t.methods = [ "identify", "config", "track", "reset", "debug", "show", "ping", "page", "hide", "off", "on" ], 
            t.factory = function(e) {
              return function() {
                var n = Array.prototype.slice.call(arguments);
                return n.unshift(e), t.push(n), t;
              };
            }, t.methods.forEach(function(e) {
              t[e] = t.factory(e);
            }), t.load = function(t) {
              var e = 3e5, n = Math.ceil(new Date() / e) * e, o = document.createElement("script");
              o.type = "text/javascript", o.async = !0, o.crossorigin = "anonymous", o.src = "https://js.driftt.com/include/" + n + "/" + t + ".js";
              var i = document.getElementsByTagName("script")[0];
              i.parentNode.insertBefore(o, i);
            };
        }
      }();
      drift.SNIPPET_VERSION = '0.3.1';
      drift.load('grn7f6frsavy');
    }
    `}
      </script> */}
      <script type="text/javascript">
        {`
          {
            (function(a,l,b,c,r,s){
              _nQc=c,r=a.createElement(l),s=a.getElementsByTagName(l)[0];
              r.async=1;
              r.src=l.src=("https:"==a.location.protocol?"https://":"http://")+b;
              s.parentNode.insertBefore(r,s);})
              (document,"script","serve.albacross.com/track.js","89033888");
          }
          `}
      </script>
      <script type="text/javascript">
        {`
          {
            window.heap=window.heap||[],heap.load=function(e,t){window.heap.appid=e,window.heap.config=t=t||{};var r=t.forceSSL||"https:"===document.location.protocol,a=document.createElement("script");a.type="text/javascript",a.async=!0,a.src=(r?"https:":"http:")+"//cdn.heapanalytics.com/js/heap-"+e+".js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(a,n);for(var o=function(e){return function(){heap.push([e].concat(Array.prototype.slice.call(arguments,0)))}},p=["addEventProperties","addUserProperties","clearEventProperties","identify","resetIdentity","removeEventProperty","setEventProperties","track","unsetEventProperty"],c=0;c<p.length;c++)heap[p[c]]=o(p[c])};
              heap.load("2700195193");
          }
            `}
      </script>
      <script id="mcjs">{`{ !function(c,h,i,m,p){m=c.createElement(h),p=c.getElementsByTagName(h)[0],m.async=1,m.src=i,p.parentNode.insertBefore(m,p)}(document,"script","https://chimpstatic.com/mcjs-connected/js/users/b385ff1132932d2efe0d96dd1/b6c7027c57b3946d23e1ac6ad.js"); }`}</script>
      <script type="application/javascript">
        {`
    (function(b, o, n, g, s, r, c) { if (b[s]) return; b[s] = {}; b[s].scriptToken = "Xy0xMDUyODIyNDc0"; r = o.createElement(n); c = o.getElementsByTagName(n)[0]; r.async = 1; r.src = g; r.id = s + n; c.parentNode.insertBefore(r, c); })(window, document, "script", "//cdn.oribi.io/Xy0xMDUyODIyNDc0/oribi.js", "ORIBI");
    `}
      </script>
    </Helmet>
    <HelmetDatoCms favicon={data.datoCmsSite.faviconMetaTags} />
    <div>
      <Header header={data} location={location} />
      <div>{children()}</div>
      <Footer location={location} />
    </div>
  </div>
)

export default TemplateWrapper

export const Index = graphql`
  query IndexQuery {
    datoCmsMenu {
      logo {
        url
        resolutions(
          width: 192
          height: 58
          imgixParams: { fm: "png", auto: "compress" }
        ) {
          ...GatsbyDatoCmsResolutions
        }
      }
    }
    datoCmsSite {
      faviconMetaTags {
        tags {
          tagName
          attributes {
            rel
            sizes
            href
            name
            content
            type
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js